import { ref, get } from "firebase/database";
import { getDocs, collection } from 'firebase/firestore';
import { database, db } from '../../firebase';

// Phase 1: fetch only units — fast, unblocks initial render
export const fetchUnitsData = async () => {
  const [unitsSnapshot, unitsFirestoreSnapshot, devicesSnapshot] = await Promise.all([
    get(ref(database, '/units')),
    getDocs(collection(db, 'units')),
    getDocs(collection(db, 'devices')),
  ]);

  const unitsData = unitsSnapshot.exists()
    ? Object.entries(unitsSnapshot.val()).map(([id, value]) => ({ ...value, id }))
    : [];

  const devicesData = devicesSnapshot.docs.map(doc => doc.data());
  const unitsFirestoreData = unitsFirestoreSnapshot.docs.map(doc => doc.data());

  const dashboardUnitsData = [
    ...unitsData.map(unit => ({ unitId: unit.unitID })),
    { unitId: 'backend' }
  ];

  return { unitsData, devicesData, unitsFirestoreData, dashboardUnitsData };
};

// Phase 2: fetch issues and historic data
export const fetchIssuesAndHistoricData = async () => {
  const [kamEyeSnapshot, osirisSnapshot] = await Promise.all([
    get(ref(database, '/kam_eye')),
    getDocs(collection(db, 'osiris')),
  ]);

  const kamEyeData = kamEyeSnapshot.exists()
    ? Object.entries(kamEyeSnapshot.val()).map(([id, value]) => ({ ...value, id }))
    : [];

  const kpodHistoricData = {};

  await Promise.all(osirisSnapshot.docs.map(async unitDoc => {
    const unitId = unitDoc.id;
    const kpodSnapshot = await getDocs(collection(db, 'osiris', unitId, 'kpod_historic'));
    kpodHistoricData[unitId] = { kpod_historic: {} };
    kpodSnapshot.forEach(doc => {
      kpodHistoricData[unitId].kpod_historic[doc.id] = doc.data();
    });
  }));

  return { kamEyeData, kpodHistoricData };
};

// Legacy combined fetch (kept for compatibility)
export const fetchAllData = async () => {
  const [units, issues] = await Promise.all([
    fetchUnitsData(),
    fetchIssuesAndHistoricData(),
  ]);

  return {
    kamEyeData: issues.kamEyeData,
    unitsData: units.unitsData,
    devicesData: units.devicesData,
    unitsFirestoreData: units.unitsFirestoreData,
    kpodHistoricData: issues.kpodHistoricData,
    dashboardUnitsData: units.dashboardUnitsData,
  };
};